<template>
	<div class="relative w-full" v-if="pdfURL">
		<iframe type="application/pdf" :width="width" :height="height" :src="pdfURL"></iframe>
	</div>
</template>

<script>
export default {
	name: 'PDFPreview',
	props: {
		pdfURL: {
			required: true,
			default: '',
		},
		height: {
			type: String,
			required: true,
		},
		width: {
			type: String,
			required: true,
		},
	},
	methods: {
		openPDF() {
			if (this.pdfURL.indexOf('#') !== -1) {
				window.open(this.pdfURL.substr(0, this.pdfURL.indexOf('#')));
			} else {
				window.open(this.pdfURL);
			}
		},
	},
};
</script>
